module.exports = __webpack_public_path__ + "static/media/card_c.7bad38e6.png";